export const SUBSTRATE_SUGGESTION_FIELDS = [
    'Id',
    'ADObjectId',
    'DisplayName',
    'EmailAddresses',
    'PeopleSubtype',
    'PeopleType',
    'PDLItemId',
    'PersonaId',
    'ImAddress',
    'JobTitle',
];
